const url = '{{formUrl}}'
const localDevUrl = 'http://localhost:8082'
const pathUrl = '/api/tokenizer'

const Tokenizer = {
  id: '',
  apikey: '',

  url: '',
  amount: '',

  iframe: null,
  container: null,
  settings: { id: '', apikey: '', amount: '' },

  constructor: (info) => {
    // Make sure apikey is set
    if (!info.apikey) { throw new Error('apikey must be set!') }
    Tokenizer.apikey = info.apikey

    // Set url
    Tokenizer.url = (info.url && info.url !== '' ? info.url : url) // Use constructor url passed, or default url var
    if (!info.url && window.location.href.indexOf('localhost') !== -1) {
      Tokenizer.url = localDevUrl.replace(/\/$/, '') + pathUrl
    } else {
      Tokenizer.url = Tokenizer.url.replace(/\/$/, '') + pathUrl
    }

    // Add apikey to url
    Tokenizer.url += '/' + Tokenizer.apikey

    // set amount
    if (info.amount) {
      Tokenizer.amount = info.amount
    }

    // Set values
    Tokenizer.id = Tokenizer.uuid()
    if (typeof info.settings === 'object') { Tokenizer.settings = info.settings }

    // Set callbacks
    if (info.onLoad) { Tokenizer.onLoad = info.onLoad }
    if (info.validCard) { Tokenizer.validCard = info.validCard }
    if (info.achOnChange) { Tokenizer.achOnChange = info.achOnChange }
    if (info.magStripeSwipe) { Tokenizer.magStripeSwipe = info.magStripeSwipe }
    if (info.onPaymentChange) { Tokenizer.onPaymentChange = info.onPaymentChange }
    if (info.submission) { Tokenizer.submission = info.submission }

    window.addEventListener('message', (e) => { Tokenizer.messageListener(e) })

    Tokenizer.iframe = Tokenizer.buildIframe()
    Tokenizer.waitForContainer(info.container, (el) => {
      // Check if element is in the DOM
      if (!el) {
        throw new Error('Could not find container')
      }

      // Add onload to iframe
      Tokenizer.iframe.onload = () => {
        // Send settings to iframe
        Tokenizer.settings.id = Tokenizer.id
        Tokenizer.settings.apikey = Tokenizer.apikey
        Tokenizer.settings.amount = Tokenizer.amount
        Tokenizer.setSettings(Tokenizer.settings)
        Tokenizer.onLoad() // Call on load
      }

      // Add iframe
      Tokenizer.container = el
      Tokenizer.container.appendChild(Tokenizer.iframe)
    })

    return Tokenizer
  },

  // Only here because it used originally here from the begining
  // DO NOT REMOVE, some clients still call create even though it doesnt do anything anymore.
  create: () => { },

  isSurchargeable: (state, bin) => {
    const blacklist = ['CO', 'CT', 'ME', 'MA']
    if (state === '') { return false }
    if (blacklist.indexOf(state.toUpperCase()) !== -1) { return false }
    if (!bin || !bin.card_type || bin.card_type.toLowerCase() !== 'credit') { return false }
    return true
  },

  // Post message to iframe
  submit: (amount)  => {
    // If there is guardian data send data to iframe
    Tokenizer.getGuardianData().then((guardianResult) => {
      if (guardianResult.events.length) {
        Tokenizer.postMessage({
          event: 'setGuardian',
          data: guardianResult
        })
      }
    }).then(() => {
      Tokenizer.postMessage({
        event: 'submit',
        data: { amount: amount }
      })
    }).catch(() => {
      Tokenizer.postMessage({
        event: 'submit',
        data: { amount: amount }
      })
    })
  },

  // Pass exp date to be set inside form
  setExpDate: (expDate) => {
    Tokenizer.postMessage({
      event: 'setExpDate',
      data: { value: expDate }
    })
  },

  // Communicate back to child
  postMessage: (msg) => {
    const w = Tokenizer.iframe.contentWindow
    if (w !== null) {
      const data = JSON.stringify(msg)
      w.postMessage(data, '*')
    }
  },

  onLoad () {},
  validCard (card) { console.log(card) },
  achOnChange (data){ console.log(data) },
  magStripeSwipe(data) { console.log(data) },
  onPaymentChange(type) { console.log(type) },
  submission (response) { console.log(response) },

  uuid: () => {
    function s4 () { return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1) }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  },

  waitForContainer(selector, callback) {
    if (!selector) {
      callback(null)
      return
    }

    const startTimeInMs = Date.now();
    const checkFrequencyInMs = 1000;
    const timeoutInMs = 10000;

    (function loopSearch() {
      if (typeof selector === 'string' && document.querySelector(selector) !== null) {
        callback(document.querySelector(selector))
        return
      } else if (typeof selector !== 'string' && selector) {
        callback(selector)
        return
      } else {
        setTimeout(() => {
          if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) {
            callback(null)
            return
          }
          loopSearch()
        }, checkFrequencyInMs)
      }
    })()
  },

  buildIframe () {
    const iframe = document.createElement('iframe')
    iframe.src = Tokenizer.url

    // Set allow payment request
    iframe.setAttribute('allow', 'payment')

    // Style
    iframe.style.display = 'block'
    iframe.style.border = 'none'
    iframe.style.margin = '0px'
    iframe.style.padding = '0px'
    iframe.style.width = '1px'
    iframe.style.minWidth = '100%'
    iframe.style.height = '30px'
    iframe.style.overflow = 'hidden'
    iframe.style.backgroundColor = 'transparent'
    iframe.style.transition = 'all .3s ease-out'

    // Attributes
    iframe.frameBorder = '0'

    return iframe
  },

  setSettings (settings) {
    Tokenizer.postMessage({
      event: 'setSettings',
      data: settings
    })
  },

  updateHeight (height) {
    if (height) {
      Tokenizer.iframe.style.height = height + 'px'
    }
  },

  getGuardianData () {
    const g = window //(window: {Guardian?: unknown}).Guardian: {getData?: () => Promise<GuardianData>}
    if (g && g.getData && typeof g.getData === 'function') {
      return g.getData()
    }
    return Promise.reject()
  },

  messageListener (e) {
    try {
      const msg = JSON.parse(e.data)
      const id = msg.id
      if (Tokenizer.id !== id) { return } // Validate messages are communicating on the same id
      const event = msg.event
      const data = msg.data
      if (!event) { return }

      switch (event) {
        case 'submission':
          Tokenizer.submission(data)
          break
        case 'validCard':
          Tokenizer.validCard(data)
          break
        case 'achOnChange':
          Tokenizer.achOnChange(data)
          break
        case 'magStripeSwipe':
          Tokenizer.magStripeSwipe(data)
          break
        case 'onPaymentChange':
          Tokenizer.onPaymentChange(data.type)
          break
        case 'setHeight':
          Tokenizer.updateHeight(data.height)
          break
      }
    } catch (e) {
      // Do nothing
    }
  }
}

export default Tokenizer
